import axios from "axios";
import { setRichieste } from "./localbase";
//const TOKEN = "Bearer 51b21f71f8df77f12f03481bab7655fd";

export default {
    /**
     *
     * @param userID id of the logges user
     * @returns array of richieste
     *
     * Get last 50 richieste for the logged user
     */
    async getRichieste(responsabileId: string) {
        const data = new FormData();
        // data.append("limit", "50");
        data.append("where[]", `richieste_user_id IN (SELECT dipendenti_id FROM rel_reparto_dipendenti WHERE reparti_id IN (select reparti_id FROM rel_reparto_responsabili WHERE dipendenti_id = '${responsabileId}'))`);
        data.append("where[richieste_stato]", "1"); // Solo richieste in attesa di approvazione
        data.append("orderby", "richieste_creation_date");
        data.append("orderdir", "desc");

        const response = await axios.post("rest/v1/search/richieste", data, {
            headers: {
                Authorization: process.env.VUE_APP_TOKEN,
            },
        });
        //console.log(response);
        return response;
    },

    /**
     * Set stato of a richiesta
     * @param richiestaId ID of the richiesta to update
     * @param stato New status (2 = approved, 3 = rejected)
     */
    async setStato(richiestaId: string, stato: string) {
        const data = new FormData();
        data.append("richieste_stato", stato);

        const response = await axios.post(`rest/v1/edit/richieste/${richiestaId}`, data, {
            headers: {
                Authorization: process.env.VUE_APP_TOKEN,
            },
        });
        return response;
    },


    /**
     *
     * @param responsabileId id of the responsible user
     * @param selectedMonth optional month in YYYY-MM format
     * @returns array of presenze
     *
     * Get presenze of the last month for the logged user, or for a specific month if provided
     */
    async getPresenze(responsabileId: string, selectedMonth?: string | null) {
        const data = new FormData();
        data.append("responsabile_id", responsabileId);
        
        // Add selected month parameter if provided
        if (selectedMonth) {
            data.append("selected_month", selectedMonth);
        }
        
        //const response = await axios.post(`http://192.168.11.140/firegui_crm_h2/modulo-hr/app/getPresenze`, data, {
        const response = await axios.post(`${process.env.VUE_APP_BASE_URL}modulo-hr/app/getPresenze`, data, {
            headers: {
                Authorization: process.env.VUE_APP_TOKEN,
            },
        });
        console.log(response);
        return response;
    },
};
